/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { getRandomId } from './getRandomId';

const getOverlayRandomId = (prefix: string | number = ''): string => {
  return getRandomId(prefix);
};

export { getOverlayRandomId };
